// removed by extract-text-webpack-plugin
module.exports = {"container":"EditInfo__container___3FEf-","message":"EditInfo__message___OX9Bi"};